import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/login/LoginPage.vue'
import NotFound from '@/views/errors/NotFountPage.vue'
import Layout from '@/layout/MyLayout.vue'

const routes: Array<RouteRecordRaw> = [
  // 根路径重定向到登录页
  {
    path: '/',
    redirect: '/login'
  },
  // 加热炉监控大屏（独立全屏布局）
  {
    path: '/heating-dashboard',
    name: 'HeatingDashboard',
    component: () => import('@/views/heating/DashboardView.vue'),
    meta: { title: '加热炉智能监控大屏', requiresAuth: true }
  },
  // 加热炉管理后台路由
  {
    path: '/heating',
    redirect: '/heating/devices',
    name: 'heating',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'devices',
        name: 'HeatingDevices',
        component: () => import('@/views/heating/DeviceManage.vue'),
        meta: { title: '设备管理', requiresAuth: true }
      },
      {
        path: 'registry',
        name: 'HeatingRegistry',
        component: () => import('@/views/heating/DeviceRegistryPage.vue'),
        meta: { title: '出厂登记', requiresAuth: true }
      },
      {
        path: 'customers',
        name: 'HeatingCustomers',
        component: () => import('@/views/heating/CustomerManage.vue'),
        meta: { title: '客户管理', requiresAuth: true }
      },
      {
        path: 'realtime',
        name: 'HeatingRealtime',
        component: () => import('@/views/heating/RealtimeMonitor.vue'),
        meta: { title: '实时监控', requiresAuth: true }
      },
      {
        path: 'alarms',
        name: 'HeatingAlarms',
        component: () => import('@/views/heating/AlarmCenter.vue'),
        meta: { title: '报警中心', requiresAuth: true }
      },
      {
        path: 'history',
        name: 'HeatingHistory',
        component: () => import('@/views/heating/HistoryData.vue'),
        meta: { title: '历史数据', requiresAuth: true }
      },
      {
        path: 'upload-history',
        name: 'UploadHistory',
        component: () => import('@/views/heating/UploadHistory.vue'),
        meta: { title: '数据查看', requiresAuth: true }
      },
      {
        path: 'report',
        name: 'HeatingReport',
        component: () => import('@/views/heating/DataReport.vue'),
        meta: { title: '数据报表', requiresAuth: true }
      },
      {
        path: 'energy',
        name: 'HeatingEnergy',
        component: () => import('@/views/heating/EnergyAnalysis.vue'),
        meta: { title: '能耗分析', requiresAuth: true }
      },
      {
        path: 'settings',
        name: 'HeatingSettings',
        component: () => import('@/views/heating/SystemSettings.vue'),
        meta: { title: '设备参数', requiresAuth: true }
      },
      {
        path: 'program',
        name: 'HeatingProgram',
        component: () => import('@/views/heating/ProgramManager.vue'),
        meta: { title: '段程序管理', requiresAuth: true }
      },
      {
        path: 'logs',
        name: 'HeatingLogs',
        component: () => import('@/views/heating/OperationLog.vue'),
        meta: { title: '操作日志', requiresAuth: true }
      }
    ]
  },
  // 登录
  {
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound'
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router
